(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2933],{

/***/ 67061:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/cliff-rosenberg",
      function () {
        return __webpack_require__(98005);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 98005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* reexport */ make; }
});

// EXTERNAL MODULE: ./src/bindings/Board.bs.js + 1 modules
var Board_bs = __webpack_require__(33498);
// EXTERNAL MODULE: ./src/components/library/SeoMeta.bs.js
var SeoMeta_bs = __webpack_require__(81036);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
// EXTERNAL MODULE: ./src/components/pages/about/board/MemberDetail.bs.js
var MemberDetail_bs = __webpack_require__(99967);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/utils/PageContentResolver.bs.js
var PageContentResolver_bs = __webpack_require__(73763);
;// CONCATENATED MODULE: ./src/components/pages/about/board/pages/CliffRosenberg.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE






function CliffRosenberg(props) {
    var f_seo_meta = function f_seo_meta(v) {
        return jsx_runtime.jsx(SeoMeta_bs/* make */.S, {
            meta: v.VAL
        });
    };
    var c = PageContentResolver_bs/* parse */.Qc(props.content);
    var seo_meta = c !== undefined ? belt_Option/* mapWithDefault */.k7(c.seo_meta, null, f_seo_meta) : null;
    return jsx_runtime.jsxs(jsx_runtime.Fragment, {
        children: [
            seo_meta,
            jsx_runtime.jsx(MemberDetail_bs/* make */.S, {
                member: Board_bs/* cliff */.SA
            })
        ]
    });
}
var make = CliffRosenberg;
var getServerSideProps = PageContentResolver_bs/* resolver */.UW;
 /* Board Not a pure module */ 

;// CONCATENATED MODULE: ./src/pages/about/cliff-rosenberg.js
__webpack_require__(14473);

var __N_SSP = true;



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7348,9774,2888,179], function() { return __webpack_exec__(67061); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);